.optionBlock {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;
}

.optionTitle {
  font-weight: 600;
  font-size: var(--font-size-sm);
}

.optionHint {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
}

.grantList {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.grantRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(8rem, 11rem) auto;
  gap: var(--space-2);
  align-items: center;
}

.grantName {
  overflow-wrap: anywhere;
}

@media (max-width: 40rem) {
  .grantRow {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .grantRow > :nth-child(2) {
    grid-column: 1 / -1;
    grid-row: 2;
  }
}
